module.exports = __webpack_public_path__ + "static/img/icon5.b400b1c0.svg";